import api from '@/services/api'

const state = {
  customers: [],
  summary: {},
  trends: [],
  loading: false,
  filters: {
    period: '12months',
    status: 'all',
    search: ''
  }
}

const mutations = {
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_CUSTOMERS (state, customers) {
    state.customers = customers
  },
  SET_SUMMARY (state, summary) {
    state.summary = summary
  },
  SET_TRENDS (state, trends) {
    state.trends = trends
  },
  SET_FILTERS (state, filters) {
    state.filters = { ...state.filters, ...filters }
  }
}

const actions = {
  async fetchDashboardData ({ commit, state }, companyId) {
    if (!companyId) return { success: false, error: 'Company ID required' }
    
    commit('SET_LOADING', true)
    
    try {
      const params = new URLSearchParams(state.filters).toString()
      const response = await api.get(`/dashboard/customers/${companyId}?${params}`)
      
      commit('SET_CUSTOMERS', response.data.customers)
      commit('SET_SUMMARY', response.data.summary)
      
      return { success: true, data: response.data }
    } catch (error) {
      const message = error.response?.data?.error || 'Failed to fetch dashboard data'
      return { success: false, error: message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchTrends ({ commit, state }, companyId) {
    if (!companyId) return { success: false, error: 'Company ID required' }
    
    try {
      const params = new URLSearchParams({ period: state.filters.period }).toString()
      const response = await api.get(`/dashboard/trends/${companyId}?${params}`)
      
      commit('SET_TRENDS', response.data)
      
      return { success: true, trends: response.data }
    } catch (error) {
      const message = error.response?.data?.error || 'Failed to fetch trends'
      return { success: false, error: message }
    }
  },

  updateFilters ({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },

  clearData ({ commit }) {
    commit('SET_CUSTOMERS', [])
    commit('SET_SUMMARY', {})
    commit('SET_TRENDS', [])
  }
}

const getters = {
  customers: state => state.customers,
  summary: state => state.summary,
  trends: state => state.trends,
  loading: state => state.loading,
  filters: state => state.filters,
  
  // Status statistics
  statusCounts: state => {
    if (!state.summary) return {}
    return {
      active: state.summary.activeCustomers || 0,
      atRisk: state.summary.atRiskCustomers || 0,
      lost: state.summary.lostCustomers || 0,
      total: state.summary.totalCustomers || 0
    }
  },

  // Top customers by revenue
  topCustomers: state => {
    return state.customers
      .filter(customer => customer.totalAmount > 0)
      .slice(0, 10)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}